import getAppCustomEnv from "../utilities/get-app-custom-env";

//#region Private Methods
let loadGAEcommercePlugin = () => {
  if (window.ga) {
    // load GA ecommerce plugin
    window.ga("require", "ecommerce");
  }
};

let trackGATransaction = async ({ id, revenue, items }) => {
  let appCustomEnv = await getAppCustomEnv();
  if (window.ga == null) return;
  window.ga("ecommerce:clear");
  window.ga("ecommerce:addTransaction", {
    id: id.toString(),
    affiliation: appCustomEnv.VUE_APP_SLEEK_ENV === "staging" ? "sg-app-staging.sleek.com" : "sg-app.sleek.com",
    revenue: revenue.toString(),
    currency: "SGD",
  });
  if (items) {
    items.forEach((item) => {
      item.id = id.toString();
      window.ga("ecommerce:addItem", item);
    });
  }
  window.ga("ecommerce:send");
};
//#endregion

export const GoogleAnalyticsMixin = {
  methods: {
    async parseGAData(paymentData) {
      try {
        if (window.ga == null) return;
        let transactionItems = (paymentData.items || []).map((item) => {
          return {
            name: item.name || item.description,
            sku: item.code,
            category: item.service,
            price: item.price.toString(),
            quantity: item.quantity || "1",
          };
        });
        await trackGATransaction({
          id: paymentData.chargeId ? paymentData.chargeId.toString() : paymentData.transaction_id.toString(),
          revenue: paymentData.amount.toString(),
          items: transactionItems,
        });
      } catch (e) {
        console.error(`Error from GA while parseGAData`, paymentData);
      }
    },
  },
  async created() {
    let component = this;

    loadGAEcommercePlugin(component);
  },
};
